<template>
    <div class="self-table-container">
      <div class="flex-row">
        <div class="item-title"><span class="title-tip">{{$t('message.date')}}:</span>{{lastDiagnosticTime}}</div>
      </div>

      <div class="table-div">
        <el-table :data="diagnosticDetail" border stripe>
          <el-table-column prop="code" :label="$t('message.paramName')">
            <template slot-scope="scope">
              <span v-if="scope.row.code == 0">{{$t('message.pn')}}</span>
              <span v-if="scope.row.code == 1">{{$t('message.androidVersion')}}</span>
              <span v-if="scope.row.code == 2">{{$t('message.romVersion')}}</span>
              <span v-if="scope.row.code == 3">{{$t('message.k21Version')}}</span>
              <span v-if="scope.row.code == 4">{{$t('message.spSystemVersion')}}</span>
              <span v-if="scope.row.code == 5">{{$t('message.spProtocolVersion')}}</span>
              <span v-if="scope.row.code == 6">{{$t('message.imei')}}</span>
              <span v-if="scope.row.code == 7">{{$t('message.meid')}}</span>
              <span v-if="scope.row.code == 8">{{$t('message.memoryTotal')}}</span>
              <span v-if="scope.row.code == 9">{{$t('message.memoryAvailable')}}</span>
              <span v-if="scope.row.code == 10">{{$t('message.flashTotal')}}</span>
              <span v-if="scope.row.code == 11">{{$t('message.flashAvailable')}}</span>
              <span v-if="scope.row.code == 12">{{$t('message.timeZone')}}</span>
              <span v-if="scope.row.code == 13">{{$t('message.language')}}</span>
              <span v-if="scope.row.code == 14">{{$t('message.location')}}</span>
              <span v-if="scope.row.code == 15">{{$t('message.mobileNetworkType')}}</span>
              <span v-if="scope.row.code == 16">{{$t('message.mobileNumber')}}</span>
              <span v-if="scope.row.code == 17">{{$t('message.mobileNetworkSignal')}}</span>
              <span v-if="scope.row.code == 18">{{$t('message.mobileIpAddress')}}</span>
              <span v-if="scope.row.code == 19">{{$t('message.mobileMonthlyDataFlow')}}</span>
              <span v-if="scope.row.code == 20">{{$t('message.networkOperatorName')}}</span>
              <span v-if="scope.row.code == 21">{{$t('message.mobileDataFlow')}}</span>
              <span v-if="scope.row.code == 22">{{$t('message.wifiMacAddress')}}</span>
              <span v-if="scope.row.code == 23">{{$t('message.wifiIpAddress')}}</span>
              <span v-if="scope.row.code == 24">{{$t('message.lanMacAddress')}}</span>
              <span v-if="scope.row.code == 25">{{$t('message.lanIpAddress')}}</span>
              <span v-if="scope.row.code == 26">{{$t('message.turnOnOffTimes')}}</span>
              <span v-if="scope.row.code == 27">{{$t('message.printerLength')}}</span>
              <span v-if="scope.row.code == 28">{{$t('message.cardTimes')}}</span>
              <span v-if="scope.row.code == 29">{{$t('message.icCardTimes')}}</span>
              <span v-if="scope.row.code == 30">{{$t('message.untouchCardTimes')}}</span>
              <span v-if="scope.row.code == 31">{{$t('message.frontCameraOpenTimes')}}</span>
              <span v-if="scope.row.code == 32">{{$t('message.backCameraOpenTimes')}}</span>
              <span v-if="scope.row.code == 33">{{$t('message.batteryTemperature')}}</span>
              <span v-if="scope.row.code == 34">{{$t('message.battery')}}</span>
              <span v-if="scope.row.code == 35">{{$t('message.batteryChargeTimes')}}</span>
              <span v-if="scope.row.code == 36">{{$t('message.mainBoardBatteryVoltage')}}</span>
              <span v-if="scope.row.code == 37">{{$t('message.turnOnTime')}}</span>
              <span v-if="scope.row.code == 38">{{$t('message.turnOnTimeSummary')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="value" :label="$t('message.value')"/>
        </el-table>
      </div>

    </div>
</template>

<script>
    export default {
        name: "TerminalDiagnosticDetail",

        props:{
          diagnosticDetail:{
            required: true
          },
          lastDiagnosticTime:{
            required: true
          }
        }
    }
</script>

<style scoped>

  .table-div {
    margin-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/terminal/TerminalDiagnosticDetail.vue